import { render, staticRenderFns } from "./DragResizeElement.vue?vue&type=template&id=58a1df78&scoped=true&"
import script from "./DragResizeElement.vue?vue&type=script&lang=js&"
export * from "./DragResizeElement.vue?vue&type=script&lang=js&"
import style0 from "./DragResizeElement.vue?vue&type=style&index=0&id=58a1df78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a1df78",
  null
  
)

export default component.exports